import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../components/Header.jsx';
import i18n from 'ar-i18n';
import Footer from '../components/Footer.jsx';

class RakutenApp extends Component {
    static propTypes = {
        dispatch: PropTypes.func,
        advertisableEid: PropTypes.string.isRequired,
        shopId: PropTypes.string,
        externalshopId: PropTypes.string,
        shopName: PropTypes.string,
        notifications: PropTypes.array,
        merchantDashAllowed: PropTypes.bool,
        isReadOnlyUser: PropTypes.bool,
        i18nLoaded: PropTypes.bool,
        children: PropTypes.object
    };

    render() {
        if (!this.props.merchantDashAllowed) {
            return this.renderDashNotAllowedMessage();
        }
        let clonedChildrenWithProps = this.props.children && React.cloneElement(this.props.children, this.props);
        return (
            <div className={ `${process.env.APP_BG_COLOR}` }>
                <Header dispatch={ this.props.dispatch } shopName={ this.props.shopName } notifications={ this.props.notifications } />
                { clonedChildrenWithProps }
                <Footer />
            </div>
        );
    }

    renderDashNotAllowedMessage() {
        return (
            <div>
                <Header shopName={ this.props.shopName } />
                <div className='dash-not-allowed-section'>
                    { i18n.gettext('You are currently using Rakuten dynamic targeting ad β ver.')} <br />
                    { i18n.gettext('You will be able to apply through UI about 3 working days after your β ver. end date is over.')}<br />
                    { i18n.gettext('Thank you very much for your understanding.')} <br /> <br />
                    { i18n.gettext('If you have anything, please talk to your EC consultant or contact here.')}<br />
                    <div className='contact-info'>
                        { i18n.gettext('MAIL: support-rdt@mail.rakuten.com')} <br />
                        { i18n.gettext('TEL: 050-5533-1899')} <br />
                        { i18n.gettext('Working hours: 9:00-18:00 (except for weekends/ public holidays)')} <br />
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}
;


export default RakutenApp;
